import { Divider } from 'antd';
import ProgressChecklist from 'components/new-ui/composed/progress-checklist/ProgressChecklist';
import ProgressChecklistHeader from 'components/new-ui/composed/progress-checklist/ProgressChecklistHeader';
import { ProgressChecklistItem } from 'components/new-ui/composed/progress-checklist/types';

type Props = {
    items: ProgressChecklistItem[];
};

const ValidationProgressSidebar = ({ items }: Props) => {
    const allPassed = items.every((item) => item.passed);
    return (
        <div
            style={{
                border: '1px solid var(--gray-4)',
                borderRadius: 6,
                paddingBlock: 16,
                paddingInline: 24,
                background: 'var(--gray-1)',
            }}
        >
            <ProgressChecklistHeader allPassed={allPassed} />
            <Divider style={{ marginBlock: 12 }} />
            <ProgressChecklist items={items} />
        </div>
    );
};

export default ValidationProgressSidebar;
